import {
  Button,
  Typography,
  IconButton,
  InputAdornment,
  TextField,
  Box,
  Grid,
  Dialog,
  Select,
  MenuItem,
  Radio,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { actions, reducer, sliceKey } from "../../../redux/slice";
import { useLandlordSaga } from "../../../redux/saga";
import { style } from "@mui/system";
import { useStyles } from "../../styles";
import { LoggerClass as Logger } from "utils/logger";

type Props = {};
const Password = ({
  showPopup,
  closePopup,
  handleChange = () => {},
  handleSelect = () => {},
}) => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: useLandlordSaga });
  const styles = useStyles();
  const [show, setShow] = useState(false);
  const [oldpassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatpassword, setRepeatPassword] = useState("");
  const [disable, setDisable] = useState(true);

  const close = () => {
    handleSelect();
  };

  useEffect(() => {
    if (oldpassword?.length && newPassword?.length && repeatpassword?.length) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [newPassword?.length, oldpassword?.length, repeatpassword?.length]);

  useEffect(() => {
    setShow(showPopup);
  }, [showPopup]);

  return (
    <Dialog open={show} className={styles.popup}>
      <Box sx={{ display: "flex", flexDirection: "column", margin: "16px" }}>
        <Typography className={styles.modalTitle}>Change password </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <div>
            <div
              className={styles.label}
              style={{ marginLeft: 10, marginRight: 0, marginTop: 16 }}
            >
              Old Password
            </div>
            <TextField
              color="primary"
              variant="outlined"
              required
              id="nickName"
              placeholder={"Enter Old Password"}
              name="clientId"
              value={oldpassword}
              type="password"
              onChange={(event) => {
                setOldPassword(event.target.value);
              }}
              className={styles.textStyle}
              style={{
                marginLeft: 0,
                marginRight: 0,
                width: "100%",
                marginBottom: 0,
              }}
            />
          </div>

          <div>
            <div
              className={styles.label}
              style={{ marginLeft: 10, marginRight: 0, marginTop: 16 }}
            >
              New Password
            </div>
            <TextField
              color="primary"
              variant="outlined"
              required
              id="nickName"
              placeholder={"Enter New Password"}
              name="clientId"
              value={newPassword}
              type="password"
              onChange={(event) => {
                setNewPassword(event.target.value);
                //   }
              }}
              className={styles.textStyle}
              style={{
                marginLeft: 0,
                marginRight: 0,
                width: "100%",
                marginBottom: 0,
              }}
            />
          </div>
          <div>
            <div
              className={styles.label}
              style={{ marginLeft: 10, marginRight: 0, marginTop: 16 }}
            >
              Repeat a New Password
            </div>
            <TextField
              color="primary"
              variant="outlined"
              required
              id="nickName"
              placeholder={"Repeat a New Password"}
              name="clientId"
              value={repeatpassword}
              type="password"
              onChange={(event) => {
                setRepeatPassword(event.target.value);
              }}
              className={styles.textStyle}
              style={{
                marginLeft: 0,
                marginRight: 0,
                width: "100%",
                marginBottom: 0,
              }}
            />
          </div>
        </Box>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 25,
          }}
        >
          <Button
            className={styles.outlinebtn}
            onClick={close}
            style={{ marginLeft: 0 }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            className={styles.signInButton}
            disabled={disable}
            onClick={handleChange}
          >
            Change
          </Button>
        </div>
      </Box>
    </Dialog>
  );
};

export default Password;
